import InnerComponent from '@Components/Purchase/DebitNotes/DebitNoteForm';
import orgContainer from '@Components/AppContainer';

const UpdateDebitNotePage = () => ((orgContainer(InnerComponent)));
export default UpdateDebitNotePage;
